import { createFileRoute, Navigate } from '@tanstack/react-router';
import { Flex } from '@televet/kibble-ui/chakra';
import { Spinner } from '@televet/kibble-ui/Spinner';
import { Radar } from '@/components/Radar/Radar';
import { useUser } from '@/providers/user';
import { useClinicEntitlements } from '@/lib/useClinicEntitlements';

export const Route = createFileRoute('/_authenticated/radar')({
  component: RouteComponent,
});

// Tracking is not wired here: Radar reads `trackEvent` off the host session.
function RouteComponent() {
  const { currentClinic } = useUser();
  const { hasFlow, hasInform, hasResolved, isLoading } = useClinicEntitlements();

  if (isLoading) {
    return (
      <Flex w="100%" h="100%" align="center" justify="center" bg="background.subtle">
        <Spinner size="md" />
      </Flex>
    );
  }

  // Same gate as the nav entry, so a typed URL cannot reach what the nav hides. `hasResolved` is
  // false when the first lookup failed, which has to send the clinic away rather than spin: the
  // query is settled, so no further render is coming. A failed refetch keeps its cached answer.
  if (!hasResolved || !hasInform || hasFlow) {
    return <Navigate to="/home" replace />;
  }

  return (
    <Flex w="100%" h="100%" overflow="auto" direction="column" bg="background.subtle">
      <Radar clinicId={currentClinic.id ?? undefined} />
    </Flex>
  );
}
